/* Structural layout only — colors come from Astryx design tokens (resolved
   inside a <Theme> scope). */

.row {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  padding-block: var(--spacing-3);
  border-bottom: 1px solid var(--color-border);
}

.row:last-child {
  border-bottom: none;
}

.index {
  font-weight: var(--font-weight-bold);
  color: var(--color-text-secondary);
}

.score {
  flex-shrink: 0;
}

.ideal {
  padding: var(--spacing-3);
  background: var(--color-background-body);
  border-radius: var(--radius-md);
}

.idealLabel {
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.excluded {
  opacity: 0.55;
}
